<template>
  <div class="top-box bg-[#F3F3F3]">
    <div class="container flex justify-between items-center h-[32px]">
      <div class="date">
        {{ date }}
      </div>
      <div class="right flex items-center text-[13px]">
        <template v-if="!user">
          <a href="/user/login" class="text-[#5A5A5A] hover:text-primary">登录</a>
          <div class="xian h-[10px] w-[1px] bg-[#5A5A5A] ml-[10px] mr-[10px]"></div>
          <a href="/user/register" class="text-[#5A5A5A] hover:text-primary">注册</a>
        </template>
        <template v-else>
          <span>当前用户：</span>
          <a href="/user/info" class="text-[#5A5A5A] hover:text-primary">{{ user.phone }}</a>
        </template>
      </div>
    </div>
  </div>
  <div class="container flex justify-between items-center h-[96px]">
    <img
      class="w-[240px] h-[46px] block cursor-pointer"
      src="../assets/image/logo.svg"
      alt="LOGO"
      @click="$router.push('/')"
    />
    <div class="search-box">
      <div class="input-box flex items-center bg-primary w-[392px] h-[38px] rounded-[4px] overflow-hidden">
        <input
          v-model="searchVal"
          class="flex-shrink flex-grow bg-white h-[34px] ml-[2px] rounded-[4px] pl-[16px] outline-none placeholder:text-[#ABABAB] text-[13px]"
          type="text"
          placeholder="请输入搜索关键字"
          @keyup.enter="searchBtn"
        />

        <button class="flex w-[80px] items-center justify-center cursor-pointer" @click="searchBtn">
          <img src="../assets/image/search.svg" alt="" />
        </button>
      </div>
      <!-- <div class="mt-2">
        <span class="mr-2 text-[#ABABAB]">热词：</span>
        <span class="mr-2 text-[#ABABAB]">海关</span>
        <span class="mr-2 text-[#ABABAB]">报关单</span>
        <span class="mr-2 text-[#ABABAB]">常见问题</span>
      </div> -->
    </div>
  </div>
  <div class="nav-box bg-primary">
    <div class="container flex justify-between items-center h-[60px]">
      <ul class="nav flex items-center">
        <li :class="activeName === '/' ? 'active' : ''"><a href="/">首页</a></li>
        <li :class="activeName === '/product' ? 'active' : ''"><a href="/product">产品服务</a></li>
        <li :class="activeName === '/news' ? 'active' : ''"><a href="/news">政策资讯</a></li>
        <li :class="activeName === '/material' ? 'active' : ''"><a href="/material">材料下载</a></li>
      </ul>
      <div class="right flex items-center cursor-pointer" @click="goInfo">
        <img src="../assets/image/user-icon.svg" alt="" />
        <span href="" class="text-[16px] ml-[10px] !text-white">管理中心</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import dayjs from "dayjs";
import { useRoute, useRouter } from "vue-router";
//  YYYY-MM-DD 星期 X
const date = ref(dayjs().format("YYYY-MM-DD dddd"));
const searchVal = ref("");
const activeName = ref("/");
const route = useRoute();
const router = useRouter();
function goInfo() {
  const token = localStorage.getItem("access_token");
  if (!token) {
    router.push("/user/login");
  } else {
    router.push("/user/info");
  }
}
const user = ref(null);
function searchBtn() {
  router.push({
    path: "/news",
    query: {
      keyword: searchVal.value,
    },
  });
}
onMounted(() => {
  activeName.value = route.path;
  user.value = JSON.parse(localStorage.getItem("user")) || null;
});
</script>

<style lang="scss" scoped>
.nav li {
  @apply relative h-[60px] flex items-center;
  a {
    @apply text-white relative block h-full leading-[60px] text-[16px]  mr-[34px];
  }
  &.active {
    a::after {
      content: "";
      @apply absolute bottom-0 left-0 w-full h-[2px] bg-white;
    }
  }
}
</style>
